import moment from 'moment'

const initialState = {
  loading: false,
  loaded: false,
  weather: null,
  description: null,
  savedDate: null,
  stepCompleted: false,
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }
    
    case 'GET_WEATHER': {
      return {
        ...state,
        loading: true
      }
    }

    case 'GET_WEATHER_COMMIT': {
      const weather = action.payload
      return {
        ...state,
        loading: false,
        loaded: true,
        savedDate: moment(),
        weather,
        stepCompleted: true,
        description: `${weather.temperature}°C ${weather.description}`
      }
    }

    case 'SET_WEATHER': {
      const description = action.payload.description
      const weatherValue = description && description.length > 0 ? description : null

      return {
        ...state,
        description: weatherValue,
        stepCompleted: !!weatherValue,
      }
    }

    default: {
      return state
    }
  }
}
